import React, { useState, useEffect } from 'react';

// Browser ke andar fast WebP banana
const compressImageToWebP = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const maxDim = 1600;
        let width = img.width;
        let height = img.height;

        if (width > height && width > maxDim) {
          height = Math.round((height * maxDim) / width);
          width = maxDim;
        } else if (height > maxDim) {
          width = Math.round((width * maxDim) / height);
          height = maxDim;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            const webpFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".webp", {
              type: 'image/webp'
            });
            resolve(webpFile);
          },
          'image/webp',
          0.82
        );
      };
    };
  });
};

const AdminEvents = () => {
  const [selectedPage, setSelectedPage] = useState('events');
  const [actionType, setActionType] = useState('add');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [passkey, setPasskey] = useState('');
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState('');
  const [liveItems, setLiveItems] = useState([]);

  // Server se select kiye hue page ka data load karna
  const fetchLiveItems = async () => {
    try {
      const res = await fetch(`${window.location.origin}/data_${selectedPage}.json?t=${Date.now()}`);
      if (res.ok) {
        const text = await res.text();
        const jsonMatch = text.match(/\[[\s\S]*\]/);
        const data = jsonMatch ? JSON.parse(jsonMatch[0]) : JSON.parse(text);
        setLiveItems(Array.isArray(data) ? data : []);
      } else {
        setLiveItems([]);
      }
    } catch {
      setLiveItems([]);
    }
  };

  useEffect(() => {
    fetchLiveItems();
    setTitle('');
    setDescription('');
  }, [selectedPage]);

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setProgress('Optimizing photos for instant upload...');
    const compressed = [];
    const previewUrls = [];

    for (const f of files) {
      const c = await compressImageToWebP(f);
      compressed.push(c);
      previewUrls.push(URL.createObjectURL(c));
    }

    setImages((prev) => [...prev, ...compressed]);
    setPreviews((prev) => [...prev, ...previewUrls]);
    setProgress('');
  };

  const removePhoto = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handlePublish = async (e) => {
    e.preventDefault();

    if (passkey.trim() !== '8504999793') {
      alert('Admin Passkey galat hai!');
      return;
    }

    // Validation: Events ke liye Title zaroori hai, Achievements ke liye Description
    if (selectedPage !== 'achievements' && !title.trim()) {
      alert('Event Heading / Title bharein!');
      return;
    }

    if (selectedPage === 'achievements' && !description.trim()) {
      alert('Achievement Description / Text bharein!');
      return;
    }

    if (images.length === 0) {
      alert('Kam se kam 1 photo select karein!');
      return;
    }

    setLoading(true);
    const BATCH_SIZE = 5;
    const total = images.length;
    const itemId = 'item_' + Date.now();

    try {
      for (let i = 0; i < total; i += BATCH_SIZE) {
        const batch = images.slice(i, i + BATCH_SIZE);
        const currentCount = Math.min(i + BATCH_SIZE, total);
        setProgress(`Uploading: ${currentCount} / ${total} photos...`);

        const formData = new FormData();
        formData.append('page', selectedPage);
        formData.append('actionType', i === 0 ? actionType : 'add');
        formData.append('title', selectedPage === 'achievements' ? '' : title.trim());
        formData.append('description', description.trim());
        formData.append('eventId', itemId);
        batch.forEach((img) => formData.append('images[]', img));

        const res = await fetch(`${window.location.origin}/upload-event.php`, {
          method: 'POST',
          body: formData,
        });

        const text = await res.text();
        const jsonMatch = text.match(/\{[\s\S]*\}/);
        const data = jsonMatch ? JSON.parse(jsonMatch[0]) : JSON.parse(text);

        if (!data.success) {
          throw new Error(data.message || 'Upload failed');
        }
      }

      alert(`Success! Sabhi ${total} photos Cloudflare R2 par upload ho gayi!`);
      setTitle('');
      setDescription('');
      setImages([]);
      setPreviews([]);
      setProgress('');
      fetchLiveItems();
    } catch (err) {
      alert('Upload Error: ' + err.message);
      setProgress('');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteItem = async (id, itemTitle, itemDesc) => {
    const displayLabel = itemTitle || (itemDesc ? itemDesc.slice(0, 30) + '...' : 'Is item');
    const keyPrompt = prompt(`"${displayLabel}" ko delete karne ke liye Admin Passkey dalein:`);
    if (!keyPrompt || keyPrompt.trim() !== '8504999793') {
      alert('Passkey galat hai!');
      return;
    }

    if (!window.confirm(`Kya aap "${displayLabel}" aur uski Cloudflare R2 photos ko delete karna chahte hain?`)) return;

    setLoading(true);
    const formData = new FormData();
    formData.append('action', 'delete');
    formData.append('id', id);
    formData.append('page', selectedPage);
    formData.append('passkey', keyPrompt.trim());

    try {
      const res = await fetch(`${window.location.origin}/upload-event.php`, {
        method: 'POST',
        body: formData,
      });
      const text = await res.text();
      const jsonMatch = text.match(/\{[\s\S]*\}/);
      const data = jsonMatch ? JSON.parse(jsonMatch[0]) : JSON.parse(text);

      if (data.success) {
        alert(data.message);
        setLiveItems(data.events || []);
      } else {
        alert('Delete Error: ' + data.message);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '40px auto', padding: '30px', background: '#fff', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', fontFamily: 'sans-serif' }}>
      <h2 style={{ textAlign: 'center', color: '#681320', marginBottom: '25px', fontWeight: '700' }}>
        Website Content & Gallery Dashboard
      </h2>

      <form onSubmit={handlePublish}>
        {/* Page Selector */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Select Page / Section to Manage:</label>
          <select value={selectedPage} onChange={(e) => setSelectedPage(e.target.value)} style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '2px solid #681320', fontWeight: '600', fontSize: '15px' }}>
            <option value="events">Events Gallery (/events)</option>
            <option value="achievements">Achievements Page (/achievements)</option>
          </select>
        </div>

        {/* Action Type */}
        <div style={{ marginBottom: '20px', padding: '15px', background: '#fdf7f7', borderRadius: '8px', border: '1px solid #f2dede' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '10px', color: '#681320' }}>Choose Action:</label>
          <div style={{ display: 'flex', gap: '30px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type="radio" name="action" checked={actionType === 'add'} onChange={() => setActionType('add')} />
              <strong>Add New ({selectedPage === 'achievements' ? 'Achievement' : 'Event'})</strong>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type="radio" name="action" checked={actionType === 'replace'} onChange={() => setActionType('replace')} />
              <strong>Replace All Old Data</strong>
            </label>
          </div>
        </div>

        {/* Title Input (Sirf Events ke liye - Achievements me Hata Diya Gya Hai) */}
        {selectedPage !== 'achievements' && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>
              Event Heading / Title:
            </label>
            <input
              type="text"
              placeholder="e.g. Annual Sports Meet 2026"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required={selectedPage !== 'achievements'}
              style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }}
            />
          </div>
        )}

        {/* Description Box (Achievements ke liye) */}
        {selectedPage === 'achievements' && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Achievement Description / Text Details:</label>
            <textarea
              rows="5"
              placeholder="e.g. A century to remember, a performance to celebrate! Congratulations, Aaryaman, on your commendable performance! Wishing you continued success..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required={selectedPage === 'achievements'}
              style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', fontFamily: 'inherit', lineHeight: '1.5' }}
            />
          </div>
        )}

        {/* Photo Upload Zone */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ border: '2px dashed #681320', borderRadius: '10px', padding: '30px', textAlign: 'center', background: '#fafafa', position: 'relative' }}>
            <input type="file" multiple accept="image/*" onChange={handleImageChange} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }} />
            <div style={{ fontSize: '36px', marginBottom: '8px' }}>⚡</div>
            <p style={{ margin: 0, fontWeight: '700', color: '#681320' }}>Drag & Drop photos here or Click to Browse</p>
            <small style={{ color: '#27ae60', fontWeight: '600' }}>Fast WebP enabled (Instant upload to Cloudflare R2)</small>
            {images.length > 0 && <p style={{ marginTop: '10px', color: '#27ae60', fontWeight: '600' }}>{images.length} photos ready</p>}
          </div>
        </div>

        {/* Previews */}
        {previews.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Selected Previews ({previews.length}):</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', maxHeight: '220px', overflowY: 'auto', padding: '10px', border: '1px solid #eee', borderRadius: '8px' }}>
              {previews.map((src, index) => (
                <div key={index} style={{ position: 'relative', width: '70px', height: '70px' }}>
                  <img src={src} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' }} />
                  <button type="button" onClick={() => removePhoto(index)} style={{ position: 'absolute', top: '-6px', right: '-6px', background: '#333', color: '#fff', border: 'none', borderRadius: '50%', width: '18px', height: '18px', cursor: 'pointer', fontSize: '11px' }}>×</button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Key */}
        <div style={{ marginBottom: '25px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '8px' }}>Admin Secret Key:</label>
          <input type="password" placeholder="Passkey daalein" value={passkey} onChange={(e) => setPasskey(e.target.value)} required style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
        </div>

        <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', background: loading ? '#888' : '#681320', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? 'Processing & Uploading...' : `+ Publish to ${selectedPage.toUpperCase()}`}
        </button>

        {progress && (
          <div style={{ textAlign: 'center', marginTop: '15px', color: '#681320', fontWeight: '700', background: '#f8d7da', padding: '10px', borderRadius: '6px' }}>
            ⏳ {progress}
          </div>
        )}
      </form>

      {/* Live Items & Delete Section */}
      <div style={{ marginTop: '50px', borderTop: '2px solid #eee', paddingTop: '30px' }}>
        <h3 style={{ color: '#681320', marginBottom: '15px' }}>
          Manage Live {selectedPage === 'achievements' ? 'Achievements' : 'Events'} ({liveItems.length})
        </h3>
        {liveItems.length === 0 ? (
          <p style={{ color: '#888' }}>Abhi {selectedPage} me koi dynamic data nahi hai.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {liveItems.map((item) => (
              <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 18px', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                <div style={{ maxWidth: '70%' }}>
                  {item.title ? (
                    <strong style={{ fontSize: '16px', color: '#333' }}>{item.title}</strong>
                  ) : null}
                  {item.description && (
                    <p style={{ margin: item.title ? '4px 0 0 0' : 0, fontSize: '13px', color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {item.description}
                    </p>
                  )}
                  <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                    {item.images?.length || 0} Photos | {item.createdAt || 'N/A'}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => handleDeleteItem(item.id, item.title, item.description)}
                  disabled={loading}
                  style={{ background: '#d9534f', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminEvents;